import { ExtensionFactory } from 'joi'

export const create = (): ExtensionFactory => joi => ({
  type: 'adsId',
  base: joi.number().greater(0).integer().unsafe(),
})
